import React, { useMemo } from "react";
import { createUseStyles } from "react-jss";
import Offer1 from "./Offer1";

interface IProps {
  offers: any[];
}

export default function Template1(props: IProps) {
  const { offers } = props;
  const classes = useStyles();

  const offer = useMemo(() => offers?.[0], [offers]);

  return (
    <div className={classes.container}>
      <Offer1 offer={offer} />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {},
});
